import React, { useState } from 'react';
import { Factory, Pencil, Plus } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { JobberFormDialog } from '@/components/jobbers/JobberFormDialog';
import { errMsg } from '@/services/staffAttendanceApi';
import { jobberMasterApi } from '@/services/jobberMasterApi';

/** Job-work 'To' comes from the Jobber Master: add the jobber when it's missing, or fix its details, then the draft reloads. */
export const JobberFixCard = ({ fix, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [jobber, setJobber] = useState(null);
  const missing = !fix.id;
  const edit = async () => {
    try { setJobber(await jobberMasterApi.get(fix.id)); setOpen(true); } catch (e) { toast.error(errMsg(e, 'Could not open the jobber')); }
  };
  return (
    <div className={`flex flex-wrap items-center gap-2 rounded-lg border px-3 py-2 ${missing ? 'border-rose-200 bg-rose-50/60' : 'border-gray-200 bg-gray-50'}`} data-testid="ewb-jobber-fix">
      <Factory className={`w-4 h-4 ${missing ? 'text-rose-700' : 'text-amber-700'}`} />
      <span className={`text-sm ${missing ? 'font-semibold text-rose-900' : 'text-gray-700'}`} data-testid="ewb-jobber-fix-text">
        {missing ? `Jobber '${fix.name}' isn't in the Jobber Master — add its GSTIN, address and PIN`
          : `To: jobber '${fix.name}' from the Jobber Master${fix.active === false ? ' (inactive)' : ''}`}
      </span>
      <Button size="sm" variant={missing ? 'default' : 'outline'} onClick={missing ? () => { setJobber(null); setOpen(true); } : edit}
        className={`ml-auto ${missing ? 'bg-[#2D5F4F] hover:bg-[#234A3D]' : ''}`} data-testid={missing ? 'ewb-jobber-add-btn' : 'ewb-jobber-edit-btn'}>
        {missing ? <><Plus className="w-4 h-4 mr-1" />Add jobber</> : <><Pencil className="w-4 h-4 mr-1" />Edit jobber</>}
      </Button>
      <JobberFormDialog open={open} jobber={jobber} initialName={fix.name} onClose={() => setOpen(false)} onSaved={() => { setOpen(false); onSaved(); }} />
    </div>
  );
};

export default JobberFixCard;
